<script>
export default {
    name: "CampusAccessList",
    data() {
        return {
            submitted: false,
            tableData: [],
            campusId: null,
            userId: null,
        };
    },
    created() {
        this.getAllCampus();
    },
    methods: {
        getAllCampus() {
            this.$store
                .dispatch("campus/GetCampus")
                .then((res) => {
                    res.data.map((x) => {
                        x.accessId = 0;
                        x.checkMe = false;
                    });
                    this.tableData = res.data;
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - getting campuses!",
                        "error"
                    );
                });
        },
        toggleCheck(row) {
            if (row.checkMe) {
                this.$store
                    .dispatch("campusaccess/CreateCampusAccess", 
                        { applicationUserId: this.userId, campusId: row.id },
                    )
                    .then((res) => {
                        row.checkMe = true;
                        row.accessId = res.data.id;
                    })
                    .catch((err) => {
                        this.showToast(
                            "Something went wrong - adding campus access!",
                            "error"
                        );
                    });
            } else {
                this.$store
                    .dispatch("campusaccess/DeleteCampusAccess", row.accessId)
                    .then((res) => {
                        row.checkMe = false;
                    })
                    .catch((err) => {
                        this.showToast(
                            "Something went wrong - removing campus access!",
                            "error"
                        );
                    });
            }
        },
        checkAccess(id, campusId) {
            this.campusId = campusId;
            this.userId = id;
            this.tableData.forEach((x) => {
                x.checkMe = false;
            });
            this.$store
                .dispatch("campusaccess/GetCampusAccess", id)
                .then((res) => {
                    res.data.forEach(item => {
                        let x = this.tableData.find(x => x.id == item.campusId);
                        if(x){
                            x.checkMe = true;
                            x.accessId = item.id;
                        }
                    })
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - getting campus access!",
                        "error"
                    );
                });
        },
    },
};
</script>
<template>
    <b-modal
        id="campus-access-modal"
        :title="`Campus Access List - ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="px-2">
            <div v-for="item in tableData" :key="item.id" class="mb-1">
                <div
                    class="
                        form-check form-checkbox-outline form-check-success
                        mb-0
                    "
                >
                    <input
                        type="checkbox"
                        :id="`customCheckcolor${item.id}`"
                        v-model="item.checkMe"
                        @change="toggleCheck(item)"
                        class="form-check-input"
                    />
                    <label
                        :for="`customCheckcolor${item.id}`"
                        class="form-check-label"
                    >
                        <span>{{ item.campusName }}</span>
                    </label>
                </div>
            </div>
        </div>
    </b-modal>
</template>